// Module
var code = `<div ng-controller="SelectCountriesCtrl" class="form-group {{form.htmlClass}} schema-form-select"
     ng-class="{
        'has-error': form.disableErrorState !== true && hasError(),
        'has-success': form.disableSuccessState !== true && hasSuccess(),
        'has-feedback': form.feedback !== false
        }"
>
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
        {{form.title}}
    </label>
    <div class="{{form.fieldHtmlClass}}">
        <ui-select multiple
                   sf-field-model
                   spinner-enabled="true"
                   remove-selected="false"
                   limit="{{form.maxItems}}"
                   class="form-control"
        >
            <ui-select-match placeholder="{{form.placeholder}}">
                {{\$item.name}}
            </ui-select-match>

            <ui-select-choices repeat="item.name as item in countries"
                               refresh="updateCountries(\$select.search, \$select.ngModel.\$\$rawModelValue)"
                               refresh-delay="0">
                <div ng-bind-html="item.value"></div>
            </ui-select-choices>

            <ui-select-no-choice>
                Not found...
            </ui-select-no-choice>

        </ui-select>
    </div>
    <div class="help-block" sf-message="form.description"></div>

</div>
`;
// Exports
module.exports = code;